<template>
    <div class="buyflow-panel
                p-0
                flex
                flex-col
                justify-between
                items-stretch">
        <div class="p-6
                    flex-grow">
            <div class="h-full
                        flex
                        flex-col
                        justify-between">
                <div class="mb-6">
                    <div class="font-bold
                                text-xl desktop:text-2xl
                                leading-snug
                                mb-2">
                        {{ name }}
                        <div class="text-sm
                                    font-book">
                            Channel Package
                        </div>
                    </div>
                    <div class="text-sm desktop:text-base
                                leading-snug">
                        <slot />
                    </div>
                </div>
                <div class="flex
                            flex-row
                            justify-between">
                    <PricePerMonth :price="price"
                                   :showPlus="false" />
                    <button
                        class="buyflow-button flex items-center"
                        :class="{ 'active': isSelected }"
                        :disabled="prereq"
                        @click="$emit('select')"
                    >
                        <template v-if="prereq">
                            <IconCircleExclamation class="mr-1" />
                            {{ prereqText }}
                        </template>
                        <template v-else-if="isSelected">
                            <IconCheck class="mr-1" />
                            Added
                        </template>
                        <template v-else>
                            <IconPlus class="mr-1" data-cy="add-tv-variety" />
                            Add
                        </template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PricePerMonth from "@/atoms/PricePerMonth"

    import IconCheck from "@/atoms/icons/IconCheck"
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"
    import IconPlus from "@/atoms/icons/IconPlus"

    export default {
        name: 'TVPackages_Package',
        components: {
            PricePerMonth,
            IconCheck,
            IconCircleExclamation,
            IconPlus,
        },
        props: {
            name: {
                type: String,
                required: true,
                default: null,
            },
            price: {
                type: Number,
                required: true,
                default: 0,
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            prereq: {
                type: Boolean,
                default: false,
            },
            prereqText: {
                type: String,
                default: null,
            },
        },
    }
</script>
